import { IPageOf, IResponse } from '@howdeniberia/core-front';
import { Observable } from 'rxjs';
import { IClient, IProjectInputDto, IProjectOutputDto, ISearchRequest, ISearchResult } from 'src/app/core/models/api/sane-project/arpa-model';

export abstract class SaneProjectContract {
  abstract search(request: ISearchRequest): Observable<IPageOf<ISearchResult>>;
  abstract getProjectById(id: number): Observable<IProjectOutputDto>;
  abstract save(project: IProjectOutputDto): Observable<IProjectOutputDto>;
  abstract getClient(id: number): Observable<IClient>;
  abstract getPricing(input: IProjectInputDto): Observable<IResponse<number>>
  abstract generateReport(projectId: number): Observable<Blob>
  abstract canBeSigned(projectId: number): Observable<IResponse<boolean>>;
}
